import { useRef } from "react";
import { useInView } from "./hooks";

/**
 * Adds `is-in` once the element scrolls into view; the motion itself lives in CSS
 * (`rm-reveal--rise | fade | zoom | unfurl`), with `delay` in seconds for staggering.
 */
const Reveal = ({ as: Tag = "div", effect = "rise", delay = 0, threshold = 0.2, className = "", style, children }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { threshold });
  return (
    <Tag
      ref={ref}
      className={`rm-reveal rm-reveal--${effect} ${inView ? "is-in" : ""} ${className}`}
      style={{ "--delay": `${delay}s`, ...style }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
